const FALLBACK_API_BASE_URL =
  'https://nexora-api.yellowsky-d5db393c.centralindia.azurecontainerapps.io/api/v1';

const LOCAL_DEV_DEFAULT = 'http://localhost:5555/api/v1';

function normalize(url: string): string {
  return url.replace(/\/+$/, '');
}

/** If user sets host only (e.g. http://localhost:5555), append /api/v1 for local dev. */
function ensureLocalApiPath(url: string): string {
  const n = normalize(url);
  try {
    const u = new URL(n);
    const isLocal =
      u.hostname === 'localhost' || u.hostname === '127.0.0.1' || u.hostname === '[::1]';
    if (!isLocal || n.includes('/api/')) return n;
    return `${n}/api/v1`;
  } catch {
    return n;
  }
}

export function getApiBaseUrl(): string {
  /**
   * When Vite dev server uses HTTPS, calling `http://localhost:5555` is mixed-content blocked.
   * Same-origin `/api/v1` goes through Vite's proxy (see vite.config.ts).
   */
  const useDevProxy =
    import.meta.env.DEV &&
    typeof window !== 'undefined' &&
    (window.location.protocol === 'https:' ||
      String(import.meta.env.VITE_USE_DEV_PROXY || '').toLowerCase() === 'true');

  if (useDevProxy) {
    return '/api/v1';
  }

  const raw = (import.meta.env.VITE_API_URL as string | undefined)?.trim();
  if (!raw) {
    // Local `npm run dev` should hit the local API by default (avoids silent prod fallback).
    if (import.meta.env.DEV) {
      return LOCAL_DEV_DEFAULT;
    }
    return FALLBACK_API_BASE_URL;
  }

  try {
    const parsed = new URL(raw);

    // Prevent non-resolving legacy app service hosts from breaking auth flows.
    if (parsed.hostname.endsWith('azurewebsites.net')) {
      return FALLBACK_API_BASE_URL;
    }

    return ensureLocalApiPath(normalize(raw));
  } catch {
    return import.meta.env.DEV ? LOCAL_DEV_DEFAULT : FALLBACK_API_BASE_URL;
  }
}